module.exports = __webpack_public_path__ + "static/media/daniel.48c5a0b3.png";